package com.merkost.handpass.api.dto.waitlist

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WaitlistSignupRequest(
    val email: String,
    val source: String? = null,
    val suburb: String? = null,
    val intent: String? = null,
    @SerialName("utm_source") val utmSource: String? = null,
    @SerialName("utm_medium") val utmMedium: String? = null,
    @SerialName("utm_campaign") val utmCampaign: String? = null,
    @SerialName("utm_content") val utmContent: String? = null,
    @SerialName("utm_term") val utmTerm: String? = null,
    val fbclid: String? = null,
    @SerialName("landing_path") val landingPath: String? = null,
    val fbc: String? = null,
    val fbp: String? = null,
    @SerialName("event_id") val eventId: String? = null,
    @SerialName("ad_consent") val adConsent: Boolean = false,
    val referrer: String? = null,
    @SerialName("website") val honeypot: String? = null,
)
